





























































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";
import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import GradientSelector from "./gradientSelector/gradientSelector.vue";
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import * as Enumerable from "linq-es5";

import * as def from "@/definitions";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import { PatternBaseLayer } from "@/model/document2/page/surface/design/layer/patternBaseLayer";

import { MathHelper } from "@/helper/mathHelper";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import RadioOn from "../resources/radioOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    DropdownList,
    RangeSlider,
    ValueEdit,
    GradientSelector,
    ColorSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    RadioOn
  }
})
export default class PatternColorFillGradient extends Vue
{
    @Prop()
    private layer!: PatternBaseLayer;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    patternColorFillGradientContentsOpenAnimate = false;
    patternColorFillGradientContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.patternColorFillGradientContentsCloseAnimate = true;
        setTimeout(() => {
            this.patternColorFillGradientContentsCloseAnimate = false;
            this.patternColorFillGradientContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
            this.openStatus.opend = true;
            this.patternColorFillGradientContentsOpenAnimate = true;
            setTimeout(() => {
                this.patternColorFillGradientContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓透明度↓↓↓↓↓
    private get opacity() {
        return this.layer.opacity;
    }
    private get opacitySliderValue() {
        return this.opacity;
    }
    private set opacitySliderValue(value) {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value) {
        this.changeLayerProperty(value, "opacity", true);
    }
    //↑↑↑↑↑透明度↑↑↑↑↑

    //↓↓↓↓↓塗りつぶしタイプ変更↓↓↓↓↓
    private changeFillType(fillType: string) {
        var layerFillType = 0;
        if (fillType == "none") {
            layerFillType = 0;
        } else if (fillType == "solid") {
            layerFillType = 1;
        } else if (fillType == "gradient") {
            layerFillType = 2;
        }

        this.changeLayerProperty(layerFillType, "fillType");
    }
    //↑↑↑↑↑塗りつぶしタイプ変更↑↑↑↑↑

    //↓↓↓↓↓種類↓↓↓↓↓
    private isStrokeTypeDropdownVisible = false;
    private get strokeTypeDropdownItems() {
        var items = new Array();
        items.push({
            id: 0,
            label: "線形",
            isSelected: this.layer.gradationType == 0
        });
        items.push({
            id: 1,
            label: "円形",
            isSelected: this.layer.gradationType == 1
        });
        return items;
    }
    private get strokeTypeText() {
        var text = "";
        if(this.layer.gradationType == 0)
        {
            text = "線形";
        }
        else
        {
            text = "円形";
        }
        return text;
    }
    //↑↑↑↑↑種類↑↑↑↑↑


    private get gradientOrientaionText(): string
    {
        return this.layer.linearGradationAngle + "°";
    }

    private setOrientation(value: number, propertyName: string)
    {
        this.changeLayerProperty(value, propertyName, true, true);
    }

    private setRadialGradationDirection(value : number)
    {
        this.changeLayerProperty(value, "radialGradationDirection", true, true);
    }

    private get linearGradationAngle(): number
    {
        return this.layer.linearGradationAngle;
    }

    private get radialGradationDirection() : number
    {
        return this.layer.radialGradationDirection;
    }


    //マウスダウン
    mousedown = false;
    selectedGradientColorPositionXBefore = 0

    onMouseup()
    {
        this.mousedown = false;
        // 位置変更確定
        this.$emit("doCommand", "fixMultiCommand", null);
    }

    private get layerGradientColors()
    {
        var colors = new Array();

        for(var i = 0; i < this.layer.getGradationPointCount(); ++i)
        {
        var grad = this.layer.getGradation(i);
        colors.push({
            id : i,
            color : grad.color,
            position : grad.position,
            isSelected : i == this.layer.selectedGradationPoint
        });
        }

        return colors;
    }

    private addGradientColor()
    {
        var selectedGradation = this.layer.getGradation(this.layer.selectedGradationPoint);
        // 色は現在選択中のもの
        var color = selectedGradation.color.clone();
        // ポジションは、最後の場合は直前のものとの間
        // それ以外は次のものとの間
        var position = 0;
        if(this.layer.selectedGradationPoint >= this.layer.getGradationPointCount() - 1)
        {
            var before = this.layer.selectedGradationPoint - 1;
            if(before >= 0)
            {
                position = (selectedGradation.position + this.layer.getGradation(before).position) / 2;
            }
        }
        else
        {
            var after = this.layer.selectedGradationPoint + 1;
            if(after < this.layer.getGradationPointCount())
            {
                position = (selectedGradation.position + this.layer.getGradation(after).position) / 2;
            }
        }
        position = MathHelper.clamp(position, 0, 100);

        this.$emit("doCommand", "addGradationOfPattern", { layer : this.layer, position : position, color : color });
    }

    private removeGradientColor()
    {
        // グラデーションの分岐点が2以下の場合は削除できない
        if(this.layer.getGradationPointCount() <= 2) { return; }

        // 選択中の分岐点削除
        this.$emit("doCommand", "removeGradationOfPattern", { layer : this.layer, index : this.layer.selectedGradationPoint});
    }

    get gradientColors() {
        return Enumerable.asEnumerable(this.layerGradientColors)
        .OrderBy(x => x.position)
        .ToArray();
    }

    get selectedGradientColor() {
        return Enumerable.asEnumerable(this.layerGradientColors)
        .Where(x => x.isSelected)
        .ToArray()[0];
    }

    get selectedGradientColorStyle() {
        return {
            background: this.selectedGradientColor.color.hex
        };
    }

    private selectGradientColor(gradientColorId: number)
    {
        if(gradientColorId < 0 || gradientColorId >= this.layer.getGradationPointCount()) { return; }

        this.mousedown = true;
        this.selectedGradientColorPositionXBefore = this.layer.getGradation(gradientColorId).position;
        // グラデーションの選択
        this.$emit("doCommand", "selectGradationOfPattern", { layer : this.layer, index : gradientColorId });
    }

    private onMousemove(moveDistance: number)
    {
        if (this.mousedown)
        {
        var newPosition = this.selectedGradientColorPositionXBefore + moveDistance;
        newPosition = MathHelper.clamp(newPosition, 0, 100);
        // 位置変更
        this.$emit("doCommand", "changeGradationPositionOfPattern", { layer : this.layer, index : this.layer.selectedGradationPoint, position : newPosition, isFinish : false });
        }
    }

    // 色変更中
    private onChangingColor(color)
    {
        this.$emit("doCommand", "changeGradationColorOfPattern", { layer : this.layer, index : this.layer.selectedGradationPoint, color : color, isFinish : false });
    }
    // 色変更完了
    private onChangedColor(color)
    {
        this.$emit("doCommand", "changeGradationColorOfPattern", { layer : this.layer, index : this.layer.selectedGradationPoint, color : color, isFinish : true });
    }

  //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
  //こいつはpropsでいらない
  isColorPickerVisible = false;
  showColorPicker() {
    this.isColorPickerVisible = true;
  }
  closeColorPicker() {
    this.isColorPickerVisible = false;
  }
  //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

  //↑↑↑↑↑グラデーション↑↑↑↑↑

    private onChangingValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, true);
    }

    private setType(value: number, propertyName: string) {
        this.isStrokeTypeDropdownVisible = false;
        this.changeLayerProperty(value, propertyName, true, true);
    }

    private changeLayerProperty(
        value: any,
        propertyName: string,
        isFinish: boolean = false,
        isOnce: boolean = false
    ) {
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value,
            isFinish: isFinish,
            isOnce: isOnce
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
